import * as actionTypes from "../actionTypes/actionTypes";
import { getLayerService } from "../services/LayerService";
import {
  createNewDrawingRule,
  deleteDrawingRule,
  deleteRule,
  createDrawingRule,
  updateDrawingRule,
  getRulesService,
} from "../services/RuleService";

const getDrawingRules = (drawingId, callback = (d) => {}) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_DRAWING_RULES,
    });

    window.startLoading();

    getRulesService(drawingId)
      .then((response) => {
        const data = response?.data;

        dispatch({
          type: actionTypes.GET_DRAWING_RULES_SUCCESS,
          payload: { drawingRules: data },
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_DRAWING_RULES_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const keepChangeRulesInState = (rules) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_DRAWING_RULES_SUCCESS,
      payload: { drawingRules: rules },
    });
  };
};

const getDrawingLayers = (drawingId) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_DRAWING_RULES,
    });
    getLayerService(drawingId)
      .then((response) => {
        const data = response?.data;

        dispatch({
          type: actionTypes.GET_DRAWING_LAYER_SUCCESS,
          payload: { layers: data },
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.GET_DRAWING_RULES_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteRules = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_DRAWING_RULE,
    });
    deleteDrawingRule(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.DELETE_DRAWING_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_DRAWING_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

const deleteRuleData = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_RULE,
    });
    deleteRule(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.DELETE_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.DELETE_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

const createRules = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CREATE_RULE,
    });
    await createDrawingRule(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.CREATE_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

const updateDrawingrRules = (gridData) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_DRAWING_RULES_SUCCESS,
      payload: gridData,
    });
  };
};

const updateRules = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_RULE,
    });
    window.startLoading();
    await updateDrawingRule(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_RULE_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const createNewRule = (requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.NEW_RULE,
    });
    await createNewDrawingRule(requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.NEW_RULE_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.NEW_RULE_FAILURE,
          payload: error,
        });
      });
  };
};

export {
  deleteRules,
  deleteRuleData,
  updateRules,
  createRules,
  updateDrawingrRules,
  getDrawingRules,
  getDrawingLayers,
  createNewRule,
  keepChangeRulesInState,
};
